import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SignaturePad = ({ onChange }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current; const ctx = c.getContext("2d");
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#1F1B16";
  }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); const p = e.touches ? e.touches[0] : e; return [p.clientX - r.left, p.clientY - r.top]; };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); };
  const end = () => { if (!drawing.current) return; drawing.current = false; setEmpty(false); onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };
  return (
    <div className="space-y-2">
      <div className="relative rounded-lg border-2 border-dashed border-border bg-white dark:bg-neutral-100">
        <canvas ref={ref} data-testid="signature-canvas" className="w-full h-40 touch-none cursor-crosshair rounded-lg"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end} onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {empty && <p className="pointer-events-none absolute inset-0 flex items-center justify-center text-xs text-neutral-400">Gambar tanda tangan di sini (mouse / jari)</p>}
      </div>
      <div className="flex justify-between items-center"><p className="text-[11px] text-muted-foreground">Opsional. Jika kosong, persetujuan tercatat secara tekstual (nama, jabatan, email, waktu, kode verifikasi).</p>
        <Button type="button" size="sm" variant="ghost" data-testid="signature-clear-button" onClick={clear} disabled={empty}><Eraser className="h-3.5 w-3.5 mr-1" />Hapus</Button></div>
    </div>
  );
};
